var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M16.6667 5.00006H11.6667V4.16673C11.6667 3.24625 10.9205 2.50006 10 2.50006C9.07952 2.50006 8.33333 3.24625 8.33333 4.16673V5.00006H3.33333C2.8731 5.00006 2.5 4.62696 2.5 4.16673C2.5 3.70649 2.8731 3.33339 3.33333 3.33339H6.775C6.91305 2.76032 7.2006 2.2341 7.60833 1.80839C8.45305 0.945226 9.69858 0.606487 10.8641 0.922944C12.0296 1.2394 12.9328 2.16154 13.225 3.33339H16.6667C17.1269 3.33339 17.5 3.70649 17.5 4.16673C17.5 4.62696 17.1269 5.00006 16.6667 5.00006Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M14.1667 18.3333H5.83334C4.45262 18.3333 3.33334 17.214 3.33334 15.8333V4.99996C3.33334 4.53972 3.70643 4.16663 4.16667 4.16663C4.62691 4.16663 5 4.53972 5 4.99996V15.8333C5 16.2935 5.3731 16.6666 5.83334 16.6666H14.1667C14.6269 16.6666 15 16.2935 15 15.8333V7.49996C15 7.03972 15.3731 6.66663 15.8333 6.66663C16.2936 6.66663 16.6667 7.03972 16.6667 7.49996V15.8333C16.6667 17.214 15.5474 18.3333 14.1667 18.3333Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M7.5 13.3333V8.33333C7.5 7.8731 7.8731 7.5 8.33333 7.5C8.79357 7.5 9.16667 7.8731 9.16667 8.33333V13.3333C9.16667 14.5833 7.5 14.5833 7.5 13.3333Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M10.8333 13.3333V8.33333C10.8333 7.8731 11.2064 7.5 11.6667 7.5C12.1269 7.5 12.5 7.8731 12.5 8.33333V13.3333C12.5 14.5833 10.8333 14.5833 10.8333 13.3333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveInvoice);
export default __webpack_public_path__ + "static/media/removeInvoice.ef019fe4d77bc20dc00e6d24179f3966.svg";
export { ForwardRef as ReactComponent };